import { MISSED_SESSIONS } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  missedSessions: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const missedSessionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MISSED_SESSIONS.REQUEST: {
      return { ...state, isLoading: true };
    }
    case MISSED_SESSIONS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        missedSessions: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case MISSED_SESSIONS.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default missedSessionsReducer;
